<template>
	<div class="settlement-status">
		<DrawerSettlement ref="drawer_settlement_details" />
		<b-card no-body>
			<b-card-header class="p-3 d-flex justify-content-between align-items-center">
				<h3 class="mb-0">Settlement</h3>
				<div class="d-flex align-items-center text-primary cursor-pointer"
					@click="viewSettlement(activeCase)">
					<p class="text-primary">View All</p>
				</div>
			</b-card-header>
			<div class="m-3">
				<div class="mb-3">
					<span class="text-muted text-xs">Settlement Amount</span>
					<p class="font-weight-600">RM {{ activeCase.settlement_amt | moneyFormatter }}</p>
				</div>
				<div>
					<span class="text-muted text-xs">Outstanding Amount</span>
					<p class="font-weight-600">RM {{ activeCase.settlement_actual_amt | moneyFormatter }}</p>
				</div>
			</div>
		</b-card>
	</div>
</template>
<script>
import DrawerSettlement from '@/views/CreditLoanCase/Drawers/DrawerSettlement'
import { mapState } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore'

export default {
	components: {
		DrawerSettlement
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase']),
	},
	methods: {
		viewSettlement(loanCase) {
			this.$refs.drawer_settlement_details.show(_gHlp.getValue(loanCase,'customer_id'),_gHlp.getValue(loanCase,'case_id'),_gHlp.getValue(loanCase,'disb_status_detail.name',null));
		}
	}
}
</script>